export default __webpack_public_path__ + "static/media/hack-tile.0292e2ef.svg";